import { TeamYear } from "./types";

export const team2021_22: TeamYear = {
  year: "2021-22",
  facultyAdvisors: [{
      id: "fac-1",
      name: "Dr. K.S.Tiwari",
      role: "Faculty Coordinator",
      image: "/team/common/tiwari-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/dr-kanchan-s-tiwari-01705171" },
    },
    {
      id: "fac-2",
      name: "Prof. Yogita Ajgar",
      role: "Faculty Coordinator",
      image: "/team/common/yogita-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/yogita-ajgar-847b1071" },
    },],
  founder: [{
      id: "founder-1",
      name: "Arnav Botre",
      role: "Founder",
      image: "/team/common/arnav.jpg",
      deptOrBranch: "Alumni - E&TC",
      social: { instagram: "https://www.instagram.com/arnav_botre14/",
      linkedin: "https://www.linkedin.com/in/arnav-botre-b2a7591b2/",
      email: "botrearnav@gmail.com"},
    },],
  coreCommittee: [{
      id: "core-1",
      name: "Arnav Botre",
      role: "President",
      image: "/team/common/arnav.jpg",
      deptOrBranch: "",
      social: {instagram: "https://www.instagram.com/arnav_botre14/",
      linkedin: "https://www.linkedin.com/in/arnav-botre-b2a7591b2/",
      email: "botrearnav@gmail.com"},
    },
    {
      id: "core-2",
      name: "Swapnil Chougule",
      role: "Vice President",
      image: "/team/2021-22/swapnil.jpg",
      deptOrBranch: "",
      social: {instagram: "https://www.instagram.com/iam_swapnil11/",
      linkedin: "https://www.linkedin.com/in/swapnil-chougule-a373101b9",
      email: "swapnilchougule1104@gmail.com"},
    },
    {
      id: "core-3",
      name: "Disha Gaikwad",
      role: "Treasurer",
      image: "/team/2021-22/disha.webp",
      deptOrBranch: "",
      social: {instagram: "https://instagram.com/dishu.1012/",
      linkedin: "https://www.linkedin.com/in/disha-gaikwad-8b69a01b8",
      email: "dishagaikwad064@gmail.com"},
    },
    {
      id: "core-4",
      name: "Akshada Shinde",
      role: "Documentation Head",
      image: "/team/2021-22/akshada_old.webp",
      deptOrBranch: "",
      social: {instagram: "https://instagram.com/__akshadaa.s/",
      linkedin: "https://www.linkedin.com/in/akshada-shinde-3604091b8",
      email: "akshadas.001@gmail.com"},
    },
    {
      id: "core-5",
      name: "Rohan Gilbile",
      role: "Publicity Co-ordinator",
      image: "/team/2021-22/rohan.jpg",
      deptOrBranch: "",
      social: { instagram: "https://www.instagram.com/gilbile_rohan/",
      linkedin: "https://www.linkedin.com/in/rohan-gilbile-63999b190/",
      email: "rohangilbile123@gmail.com"},
    },
    {
      id: "core-6",
      name: "Ramsha Shaikh",
      role: "Event Co-ordinator",
      image: "/team/2021-22/ramsha.webp",
      deptOrBranch: "",
      social: {instagram: "https://instagram.com/_ramshaaaa/",
      linkedin: "https://www.linkedin.com/in/ramsha-shaikh-191844210",
      email: "ramshashaikh777@gmail.com"},
    },
    {
      id: "core-7",
      name: "Hemant Mankar",
      role: "Social Media Head",
      image: "/team/2021-22/hemant_old.webp",
      deptOrBranch: "",
      social: {instagram: "http://instagram.com/hemant_._26",
      linkedin: "https://www.linkedin.com/in/hemant-mankar-3204a7225",
      email: "hemantmankar007@gmail.com"},
    },
    {
      id: "core-8",
      name: "Vaishnavi Bhale",
      role: "Student Co-ordinator",
      image: "/team/2021-22/vaishnavi_old.webp",
      deptOrBranch: "",
      social: {instagram: "https://instagram.com/vaishnavi._.04/",
      linkedin: "https://www.linkedin.com/in/vaishnavi-bhale-194844210",
      email: "vaishnavibhale44@gmail.com"},
    },
    {
      id: "core-9",
      name: "Akash Bondare",
      role: "Student Co-ordinator",
      image: "/team/2021-22/akash.jpg",
      deptOrBranch: "",
      social: {instagram: "https://www.instagram.com/_akash_b08/",
      linkedin: "https://www.linkedin.com/in/akash-bondare-53a6451a5",
      email: "akashbondare504@gmail.com"},
    },
    {
      id: "core-10",
      name: "Sanvidha Haribhakta",
      role: "Student Co-ordinator",
      image: "/team/2021-22/sanvidha.jpg",
      deptOrBranch: "",
      social: {instagram: "https://www.instagram.com/sanvidha_/",
      linkedin: "https://www.linkedin.com/in/sanvidha-haribhakta-12a215213/",
      email: "haribhaktasanvidha@gmail.com"},
    },
    ],
};

export {}; // ✅ This ensures it is treated as a module
